__turbopack_context__.v({
  "className": "orbitron_edf8d9fd-module__QI9G6a__className",
});
